(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    // Legal consent in the cart: save when it was accepted (the order keeps the cart attribute as proof)
  // and let the express checkouts through only once it is checked. Delegated, so it survives cart re-renders.
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.id !== 'CartLegalConsent') return;

    const acceptedAt = new Date().toLocaleString('es-ES', { timeZone: 'Europe/Madrid' });
    input.value = input.checked ? `Acepta los Términos del servicio y la Política de privacidad · ${acceptedAt}` : 'Aceptado';

    document.querySelectorAll('.cart__ctas .additional-checkout-buttons').forEach((buttons) => {
      buttons.inert = !input.checked;
    });

    fetch(Theme.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Aceptación legal': input.checked ? input.value : '' } }),
    }).catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-group-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-group-slider')) {
    customElements.define(
      'custom-group-slider',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;

          const viewport = this.querySelector('[data-slider-viewport]');
          const controls = this.querySelector('.custom-group-slider__controls');
          const previous = this.querySelector('[data-slider-previous]');
          const next = this.querySelector('[data-slider-next]');

          if (!viewport || !controls || !previous || !next) return;

          const sliderGroup = this.closest('.group-block--with-slider');
          const sectionContent = this.closest('.section-content-wrapper');
          const sliderHost = sliderGroup?.parentElement;
          const hostHeading = Array.from(sliderHost?.children ?? []).find(
            (child) =>
              child !== sliderGroup &&
              child.matches?.('.text-block, [role="heading"], h1, h2, h3, h4, h5, h6')
          );

          if (
            sliderGroup?.classList.contains('group-block--slider-arrows-section_title') &&
            sectionContent &&
            sliderHost &&
            sliderHost !== sectionContent
          ) {
            const headerContainer = hostHeading ? sliderHost : sectionContent;

            headerContainer.classList.add('custom-group-slider-section-header');
            if (headerContainer !== sliderHost) {
              sliderHost.classList.add('custom-group-slider__host--controls-moved');
            }
            headerContainer.insertBefore(controls, headerContainer.children[1] ?? null);
          }

          const mobileMedia = window.matchMedia('(max-width: 749px)');
          let frame = null;

          const updateControls = () => {
            const maximumScroll = viewport.scrollWidth - viewport.clientWidth;
            const hasOverflow = maximumScroll > 2;

            controls.hidden = !hasOverflow;
            previous.disabled = !hasOverflow || viewport.scrollLeft <= 2;
            next.disabled = !hasOverflow || viewport.scrollLeft >= maximumScroll - 2;
          };

          const updateViewportHeight = () => {
            if (!mobileMedia.matches) {
              viewport.style.height = '';
              return;
            }

            const slides = Array.from(viewport.children);

            if (!slides.length) return;

            viewport.style.height = 'auto';

            const height = Math.ceil(
              slides.reduce((tallest, slide) => Math.max(tallest, slide.getBoundingClientRect().height), 0)
            );

            if (height > 0) {
              viewport.style.height = `${height}px`;
            }
          };

          const update = () => {
            updateControls();
            updateViewportHeight();
          };

          const scheduleUpdate = () => {
            if (frame) return;

            frame = requestAnimationFrame(() => {
              frame = null;
              update();
            });
          };

          const move = (direction) => {
            const slide = viewport.firstElementChild;

            if (!slide) return;

            const gap = parseFloat(getComputedStyle(viewport).columnGap) || 0;

            viewport.scrollBy({
              left: direction * (slide.getBoundingClientRect().width + gap),
              behavior: 'smooth',
            });

            window.setTimeout(scheduleUpdate, 260);
          };

          previous.addEventListener('click', () => move(-1));
          next.addEventListener('click', () => move(1));
          viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
          viewport.addEventListener('scrollend', scheduleUpdate, { passive: true });
          mobileMedia.addEventListener('change', scheduleUpdate);
          window.addEventListener('resize', scheduleUpdate, { passive: true });

          const resizeObserver = new ResizeObserver(scheduleUpdate);
          resizeObserver.observe(viewport);
          Array.from(viewport.children).forEach((slide) => resizeObserver.observe(slide));

          requestAnimationFrame(update);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
